import { useEffect } from 'react';

import { SalesSummaryPrint } from './sales-summary-print';
// import { OrderInvoicePrinting } from './order-invoice-printing';

import { usePrintManagement } from './usePrintManagement';

import type { ComponentType } from 'react';

let OrderInvoice: ComponentType = () => null;

export function PrintManagement() {
  const {
    enableOrderToPrint,
    salesSummaryPrint,
    showNewOrderInvoice,
  } = usePrintManagement();

  // TODO: remove all related to OldOrderBill when its not needed anymore
  useEffect(() => {
    if (showNewOrderInvoice !== null) {
      import('./order-invoice-printing').then(module => {
        OrderInvoice = showNewOrderInvoice
          ? module.OrderInvoicePrinting
          : module.OldOrderBill;
      });
    }
  }, [showNewOrderInvoice]);

  return (
    <aside aria-label='print-management'>
      {/*{enableOrderToPrint && <OrderInvoicePrinting />}*/}
      {enableOrderToPrint && <OrderInvoice />}
      {salesSummaryPrint && <SalesSummaryPrint />}
    </aside>
  );
}
